import { Alert, Button, Flex, Text } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';

export type ChatLoadErrorProps = {
  message: string;
  retryLabel: string;
  isRetrying: boolean;
  onRetry: () => void;
  /** `alert` is a framed block, `inline` a line of text with a link button. */
  variant?: 'alert' | 'inline';
};

export const ChatLoadError = ({
  message,
  retryLabel,
  isRetrying,
  onRetry,
  variant = 'alert',
}: ChatLoadErrorProps) =>
  variant === 'alert' ? (
    <Alert color='red' icon={<IconExclamationCircle size={16} />}>
      <Flex align='center' justify='space-between' gap={12} wrap='wrap'>
        <Text size='sm'>{message}</Text>
        <Button
          size='xs'
          variant='light'
          color='red'
          loading={isRetrying}
          onClick={onRetry}
        >
          {retryLabel}
        </Button>
      </Flex>
    </Alert>
  ) : (
    <Flex align='center' gap='sm'>
      <Text c='red' size='sm' role='alert'>
        {message}
      </Text>
      <Button
        variant='subtle'
        size='compact-sm'
        onClick={onRetry}
        loading={isRetrying}
      >
        {retryLabel}
      </Button>
    </Flex>
  );
